import { showErrorToast } from "src/lib/utils";
import axios from "axios";
import env from "src/config/env";

export const authApi = axios.create({
	baseURL: env.REACT_APP_API_BASE_URL,
	headers: { "Content-Type": "application/json" },
});

export const onResFulfilled = (response) => response.data;

export const onResRejected = (error) => {
	if (process.env.NODE_ENV === "development") {
		console.error(error);
	}

	if (["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error.code)) {
		showErrorToast("Network error", {
			description: "Please check your connection and try again",
			closeButton: true,
		});

		return Promise.reject(error.response?.data?.message || error.response);
	}

	if (error?.response?.status === 403) {
		showErrorToast(error.response?.data?.message || "Permission denied", {
			closeButton: true,
		});
		return Promise.reject(error.response?.data?.message || error.response);
	}

	showErrorToast(error.response?.data?.message || "Something went wrong", {
		closeButton: true,
	});

	return Promise.reject(error.response?.data?.message || error.response);
};

authApi.interceptors.response.use(onResFulfilled, onResRejected);

export const loginFn = (data) => authApi.post("/auth/login", data);

export const register = (data) => authApi.post("/auth/register", data);

export const forgotPassword = (data) => authApi.post("/auth/forgot-password", data);

export const resetPassword = (data) => authApi.post("/auth/reset-password", data);

export const verifyOtp = (data) => authApi.post("/auth/verify_otp", data);

export const sendOtp = (data) => authApi.post("/auth/send-otp", data);
